import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import { CommercialAutoVideoReadiness } from "./types";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/admin/commercial-auto-video`;

export async function getCommercialAutoVideoReadiness(): Promise<CommercialAutoVideoReadiness> {
    try {
        const headers = await getAuthHeader();
        const response = await axios.get<CommercialAutoVideoReadiness>(
            `${BASE_URL}/readiness`,
            { headers }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching commercial auto-video readiness:", error);
        throw error;
    }
}
